import { ChangeDetectionStrategy, Component, ElementRef, signal, viewChild } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { SliderGalerieImages } from '@components/slider-galerie-images/models';
import { ImageComponent } from '@shared/components/image';
import { SvgComponent } from '@shared/components/svg';

@Component({
  selector: 'app-slider-galerie-images',
  templateUrl: './slider-galerie-images.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImageComponent, SvgComponent],
})
export class SliderGalerieImagesComponent extends AbstractDynamicComponent<SliderGalerieImages> {
  readonly slidesElementRef = viewChild.required<ElementRef<HTMLElement>>('slidesElementRef');
  currentSliderIndex = signal(0);

  moveSlider(direction: 'prev' | 'next') {
    const nSlides = 5;

    const slideWidth = this.slidesElementRef().nativeElement.clientWidth;
    let newIndex = this.currentSliderIndex();

    newIndex = (direction === 'next' ? newIndex + 1 : newIndex - 1 + nSlides) % nSlides;

    this.currentSliderIndex.set(newIndex);
    this.slidesElementRef().nativeElement.scrollTo({
      left: newIndex * slideWidth,
      behavior: 'smooth',
    });
  }
}
